export default __webpack_public_path__ + "static/media/uk.b0ed7a94.svg";